import { createContext } from "react";
import { EventsTrackId } from "../../../types/EventsTrack.interface";

const EventsTrackParentIdContext = createContext<EventsTrackId | EventsTrackId[]>(null);

export default EventsTrackParentIdContext;